module.exports = __webpack_public_path__ + "img/charles-thomson.366deadd.png";